import ApiService from "./api.service";
import SessionService from "./session.service";
import { getApiBaseUrl } from "../utils/baseUrl";

export default {
	async login(payload, option) {
		let loginInfo = await ApiService.post(getApiBaseUrl() + "/login", payload, option).then(res => res.data).catch((err) => {
			if (err) {
				return false;
			}
		});
		if(!loginInfo) return false;
		const { session, dataUser } = loginInfo;
		SessionService.setSession(session.id,session.idUser, session.email);
		SessionService.setSessionState(dataUser.stateCgu, dataUser.stateOnboarding, dataUser.idSociete, dataUser.idExt);
		return true;
	}
};